module.exports = __webpack_public_path__ + "img/business_img3.bd45ade2.jpg";